export interface VariationTableProps {
    defaultValue?: string[]
    onChange?: (value: string[]) => void
    disabled?: boolean
}

export type VariationType = {
    description: string
    variation: boolean
    detail: string
}

export const DescriptionMap = new Map<number, string>([
    [0, 'Inserimento Particelle Catastali'],
    [1, 'Eliminate Particelle Catastali'],
    [2, 'Inserimento Strutture Aziendali'],
    [3, 'Eliminate Strutture Aziendali'],
    [4, 'Inserimento Attività'],
    [5, 'Eliminata Attività'],
    [6, 'Aumento o diminuzione di superificie condotta'],
    [7, "Cambio dell'ODC di riferimento"],
    [8, 'Altro (specificare...)'],
])